import { FC, ReactNode } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { GLOSSARY, type GlossaryKey } from '@/data/glossary';

interface InfoTooltipProps {
  termKey: GlossaryKey;
  children?: ReactNode;
  /** Mostra só o ícone "?" sem repetir o termo ao lado */
  iconOnly?: boolean;
}

/**
 * Tooltip contextual que explica um termo do glossário ao passar o mouse
 * (ou tap-and-hold no mobile). Acessível via aria-label.
 */
const InfoTooltip: FC<InfoTooltipProps> = ({ termKey, children, iconOnly = false }) => {
  const entry = GLOSSARY[termKey];
  if (!entry) return <>{children}</>;

  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span className="inline-flex items-center gap-1 cursor-help align-middle">
            {!iconOnly && children}
            <span
              className="material-symbols-outlined text-content-muted hover:text-content-secondary transition-colors"
              style={{ fontSize: '14px' }}
              aria-label={`Mais sobre ${entry.term}`}
              role="img"
            >
              help
            </span>
          </span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            sideOffset={5}
            className="max-w-xs bg-surface-card border border-theme-border rounded-lg shadow-lg p-3 z-[60]"
          >
            <p className="text-sm font-bold text-content-primary mb-1">{entry.term}</p>
            <p className="text-xs text-content-secondary">{entry.description}</p>
            <Tooltip.Arrow className="fill-theme-border" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default InfoTooltip;
